import styled from "styled-components";

export const Wrapper = styled.div`
  width: 340px;
  background: #f0f2f5;
  position: absolute;
  top: 0;
  right: 0;
  bottom: 0; /* Garante altura total do container pai */
  z-index: 1;
  transition: all 0.2s ease;
  display: flex;
  flex-direction: column;
  overflow: hidden;

  @media (max-width: 1200px) {
    width: 320px;
  }

  @media (max-width: 768px) {
    width: 100%;
    height: 100vh;
    position: fixed;
    top: 0;
    right: 0;
    bottom: 0;
    z-index: 1001;
  }
`;

export const Header = styled.header`
  background: #008069;
  min-height: 108px;
  width: 100%;
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  padding: 16px 0px 14px 0px;
  flex-shrink: 0;

  @media (max-height: 800px) {
    min-height: 50px;
    padding: 8px 0px;
  }

  @media (max-width: 768px) {
    min-height: 90px;
    padding: 14px 0px 12px 0px;
  }
`;

export const Back = styled.div`
  display: flex;
  align-items: center;
  padding: 0 20px;

  svg {
    width: 24px;
    height: 24px;
    cursor: pointer;
    color: white;
    margin-right: 24px;
    transition: transform 0.2s;

    &:hover {
      transform: scale(1.1);
    }
  }

  h3 {
    color: #ffffff;
    font-size: 17px;
    font-weight: 500;
  }

  @media (max-height: 800px) {
    padding: 0 14px;

    svg {
      width: 20px;
      height: 20px;
      margin-right: 16px;
    }

    h3 {
      font-size: 14px;
    }
  }

  @media (max-width: 768px) {
    padding: 0 16px;

    svg {
      width: 22px;
      height: 22px;
      margin-right: 20px;
    }

    h3 {
      font-size: 16px;
    }
  }
`;

export const ContentScroll = styled.div`
  flex: 1;
  min-height: 0; /* Essencial para flexbox permitir scroll interno */
  overflow: hidden;
  display: flex;
  flex-direction: column;
`;

export const UserImage = styled.div`
  display: flex;
  justify-content: center;
  padding: 20px 16px 12px;
  text-align: center;
  background: #f0f2f5;
  flex-shrink: 0;

  img {
    border-radius: 50%;
    width: 100px;
    height: 100px;
    object-fit: cover;
    border: 3px solid #fff;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
  }

  @media (max-height: 800px) {
    padding: 8px 16px 4px;

    img {
      width: 56px;
      height: 56px;
      border-width: 2px;
    }
  }

  @media (max-width: 768px) {
    padding: 16px 16px 10px;

    img {
      width: 90px;
      height: 90px;
    }
  }
`;

export const UserData = styled.div`
  background: #fff;
  padding: 12px 16px;
  box-shadow: 0 1px 2px rgba(0, 0, 0, 0.08);
  margin-bottom: 8px;
  flex-shrink: 0;

  > span:first-child {
    font-size: 12px;
    font-weight: 500;
    color: #008069;
    display: block;
    margin-bottom: 6px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  p {
    font-size: 15px;
    margin: 0;
  }

  /* Quando contém a lista de pedidos (último item), permitir crescer */
  &:last-child {
    flex: 1 1 auto;
    min-height: 150px;
    display: flex;
    flex-direction: column;
    overflow: hidden;
    margin-bottom: 0;
    color: #111b21;
    word-break: break-word;
  }

  @media (max-height: 800px) {
    padding: 6px 14px;
    margin-bottom: 4px;

    > span:first-child {
      font-size: 10px;
      margin-bottom: 2px;
    }

    p {
      font-size: 13px;
    }

    &:last-child {
      min-height: 100px;
    }
  }

  @media (max-width: 768px) {
    padding: 10px 14px;
    margin-bottom: 6px;

    > span:first-child {
      font-size: 11px;
    }

    p {
      font-size: 14px;
    }
  }
`;

// Estatísticas do cliente
export const StatsContainer = styled.div`
  background: linear-gradient(135deg, #008069, #00a884);
  padding: 14px 16px;
  margin-bottom: 8px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 20px;
  flex-shrink: 0;

  .stat-item {
    display: flex;
    flex-direction: column;
    align-items: center;
    text-align: center;
  }

  .stat-value {
    font-size: 16px;
    font-weight: 600;
    color: #fff;
  }

  .stat-label {
    font-size: 11px;
    color: rgba(255, 255, 255, 0.85);
    margin-top: 2px;
    text-transform: uppercase;
    letter-spacing: 0.3px;
  }

  @media (max-height: 800px) {
    padding: 6px 12px;
    margin-bottom: 4px;
    gap: 14px;

    .stat-value {
      font-size: 13px;
    }

    .stat-label {
      font-size: 9px;
      margin-top: 1px;
    }

    .stat-divider {
      height: 22px;
    }
  }

  .stat-divider {
    width: 1px;
    height: 32px;
    background: rgba(255, 255, 255, 0.3);
  }
`;

// Lista de pedidos - Container com scroll
export const PedidosList = styled.div`
  flex: 1 1 auto;
  display: block; /* Não usar flex aqui para evitar compressão dos cards */
  margin-top: 8px;
  overflow-y: auto;
  overflow-x: hidden;
  padding-right: 4px;
  padding-bottom: 16px;
  min-height: 0;

  /* Espaçamento entre cards */
  & > * + * {
    margin-top: 8px;
  }

  &::-webkit-scrollbar {
    width: 5px;
  }

  &::-webkit-scrollbar-track {
    background: #f0f2f5;
    border-radius: 3px;
  }

  &::-webkit-scrollbar-thumb {
    background-color: rgba(0, 128, 105, 0.4);
    border-radius: 3px;

    &:hover {
      background-color: rgba(0, 128, 105, 0.6);
    }
  }
`;

// Card do pedido expandível
export const PedidoCard = styled.div`
  background: #f8f9fa;
  border-radius: 10px;
  overflow: hidden;
  border: 1px solid #e9ecef;
  transition: all 0.2s ease;
  flex-shrink: 0; /* Nunca encolher */

  &:hover {
    border-color: #d1d5db;
    box-shadow: 0 2px 8px rgba(0, 0, 0, 0.06);
  }
`;

export const PedidoCardHeader = styled.div`
  padding: 10px 12px;
  cursor: pointer;
  user-select: none;
  min-height: 70px; /* Altura mínima para o card não colapsar */

  .pedido-main {
    display: flex;
    justify-content: space-between;
    align-items: flex-start;
    margin-bottom: 8px;
  }

  .pedido-numero-status {
    display: flex;
    align-items: center;
    gap: 8px;
  }

  .numero {
    font-weight: 700;
    font-size: 15px;
    color: #111b21;
  }

  .pedido-data {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: #667781;

    svg {
      color: #8696a0;
    }
  }

  .pedido-resumo {
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding-top: 8px;
    border-top: 1px solid #e9ecef;
  }

  .info-row {
    display: flex;
    flex-wrap: wrap;
    gap: 6px;
  }

  .info-item {
    display: flex;
    align-items: center;
    gap: 3px;
    font-size: 10px;
    color: #667781;
    background: #fff;
    padding: 2px 6px;
    border-radius: 10px;

    svg {
      color: #8696a0;
    }
  }

  .valor-expand {
    display: flex;
    align-items: center;
    gap: 6px;
  }

  .valor {
    font-weight: 700;
    font-size: 14px;
    color: #008069;
  }

  .valor-expand svg {
    color: #8696a0;
    transition: transform 0.2s;
  }
`;

export const PedidoCardDetails = styled.div`
  background: #fff;
  padding: 10px 12px;
  border-top: 1px solid #e9ecef;

  .itens-title {
    font-size: 11px;
    font-weight: 600;
    color: #667781;
    text-transform: uppercase;
    letter-spacing: 0.3px;
    margin-bottom: 8px;
  }

  .itens-lista {
    display: flex;
    flex-direction: column;
    gap: 8px;
  }

  .item-container {
    padding-bottom: 8px;
    border-bottom: 1px dashed #f0f2f5;

    &:last-child {
      border-bottom: none;
      padding-bottom: 0;
    }
  }

  .item-row {
    display: flex;
    align-items: flex-start;
    gap: 8px;
    font-size: 13px;
    color: #111b21;

    &.entrega {
      border-top: 1px dashed #e9ecef;
      margin-top: 8px;
      padding-top: 8px;
      color: #667781;
    }

    &.desconto {
      color: #059669;
    }
  }

  .item-qtd {
    font-weight: 600;
    color: #008069;
    min-width: 24px;
    flex-shrink: 0;
  }

  .item-nome {
    flex: 1;
    word-break: break-word;
  }

  .item-preco {
    font-weight: 500;
    color: #667781;
    font-size: 12px;
    flex-shrink: 0;

    &.desconto-valor {
      color: #059669;
    }
  }

  /* Adicionais */
  .adicionais-lista {
    margin-left: 32px;
    margin-top: 4px;
    padding-left: 8px;
    border-left: 2px solid #e9ecef;
  }

  .adicional-row {
    display: flex;
    align-items: center;
    gap: 4px;
    font-size: 11px;
    color: #667781;
    padding: 2px 0;
  }

  .adicional-bullet {
    color: #008069;
    font-weight: 600;
    font-size: 12px;
  }

  .adicional-nome {
    flex: 1;
  }

  .adicional-preco {
    color: #8696a0;
    font-size: 10px;
  }

  /* Observação do item */
  .item-obs {
    margin-left: 32px;
    margin-top: 4px;
    font-size: 11px;
    color: #8696a0;
    font-style: italic;
  }

  /* Observação geral do pedido */
  .obs {
    margin-top: 10px;
    padding: 8px;
    background: #fff9e6;
    border-radius: 6px;
    font-size: 12px;
    color: #92400e;
    border-left: 3px solid #f59e0b;

    strong {
      color: #78350f;
    }
  }
`;

export const StatusBadge = styled.span`
  font-size: 9px;
  padding: 3px 8px;
  border-radius: 10px;
  font-weight: 600;
  text-transform: uppercase;
  letter-spacing: 0.3px;
  white-space: nowrap;

  ${({ status }) => {
    switch(status) {
      case '0': return 'background: #fef3c7; color: #92400e;'; // Pendente
      case '1': return 'background: #dbeafe; color: #1e40af;'; // Análise
      case '2': return 'background: #fce7f3; color: #9d174d;'; // Produção
      case '3': return 'background: #d1fae5; color: #065f46;'; // Pronto
      case '4': return 'background: #e5e7eb; color: #374151;'; // Finalizado
      default: return 'background: #f3f4f6; color: #6b7280;';
    }
  }}
`;

export const LoadingContainer = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  padding: 24px;
  color: #667781;
  font-size: 13px;
`;

export const EmptyMessage = styled.p`
  color: #667781;
  font-size: 13px;
  text-align: center;
  padding: 16px 0;
  margin: 0;
  background: #f8f9fa;
  border-radius: 8px;
  margin-top: 8px;
`;

// Componentes para edição de nome
export const NameDisplay = styled.div`
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 8px;

  p {
    flex: 1;
    font-size: 15px;
    margin: 0;
    color: #111b21;
  }
`;

export const EditIconButton = styled.button`
  background: transparent;
  border: none;
  padding: 6px;
  cursor: pointer;
  color: #8696a0;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  &:hover {
    background: #f0f2f5;
    color: #008069;
  }
`;

export const EditNameContainer = styled.div`
  display: flex;
  align-items: center;
  gap: 8px;
  margin-top: 4px;
`;

export const NameInput = styled.input`
  flex: 1;
  padding: 8px 12px;
  font-size: 15px;
  border: 1px solid #d1d7db;
  border-radius: 8px;
  outline: none;
  color: #111b21;
  background: #fff;
  transition: border-color 0.2s ease;

  &:focus {
    border-color: #008069;
  }

  &::placeholder {
    color: #8696a0;
  }
`;

export const EditActions = styled.div`
  display: flex;
  gap: 4px;
`;

export const EditButton = styled.button`
  width: 32px;
  height: 32px;
  border-radius: 50%;
  border: none;
  cursor: pointer;
  display: flex;
  align-items: center;
  justify-content: center;
  transition: all 0.2s ease;

  ${({ $variant }) => $variant === 'save' ? `
    background: #008069;
    color: #fff;

    &:hover:not(:disabled) {
      background: #006d5b;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  ` : `
    background: #f0f2f5;
    color: #667781;

    &:hover:not(:disabled) {
      background: #e9ecef;
      color: #ef4444;
    }

    &:disabled {
      opacity: 0.5;
      cursor: not-allowed;
    }
  `}
`;
